import { createAction, props } from '@ngrx/store';

import { RefrigerationCircuitMessagesData } from '@vi-iot/client';

export namespace RefrigerationCircuitMessagesActions {
  export enum Type {
    GET_REFRIGERATION_CIRCUIT_MESSAGES = '[REFRIGERATION CIRCUIT MESSAGES] Get refrigeration circuit messages',
    GET_REFRIGERATION_CIRCUIT_MESSAGES_SUCCESS = '[REFRIGERATION CIRCUIT MESSAGES] Get refrigeration circuit messages success',
    GET_REFRIGERATION_CIRCUIT_MESSAGES_ERROR = '[REFRIGERATION CIRCUIT MESSAGES] Get refrigeration circuit messages error',
  }

  export const getRefrigerationCircuitMessages = createAction(
    Type.GET_REFRIGERATION_CIRCUIT_MESSAGES
  );

  export const getRefrigerationCircuitMessagesSuccess = createAction(
    Type.GET_REFRIGERATION_CIRCUIT_MESSAGES_SUCCESS,
    props<{
      messages: RefrigerationCircuitMessagesData[];
    }>()
  );

  export const getRefrigerationCircuitMessagesError = createAction(
    Type.GET_REFRIGERATION_CIRCUIT_MESSAGES_ERROR,
    props<{
      error: any;
    }>()
  );
}
